import isEmpty from 'lodash/isEmpty';
import unescape from 'lodash/unescape';
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {compose} from 'redux';
import {connect} from 'react-redux';
import moment from 'moment';
import IconTimes from '@spothero/icons/times';
import Button from '@spothero/ui/button';
import Image from 'common/image/Image';
import withConfig from 'config/withConfig';
import {toggleInfoPanelView} from 'search/search-actions';

export const DestinationInfoPanel = ({
    title,
    imageId,
    imageAlt,
    address,
    city,
    state,
    description,
    event,
    displayEventDateFormat,
    onHideInfoPanelClick,
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const classes = classNames('DestinationInfoPanel', {
        'DestinationInfoPanel-closing': isClosing,
    });
    const onCloseClick = () => {
        setIsClosing(true);

        setTimeout(() => {
            onHideInfoPanelClick();
        }, 250); // 250 is animation time of the fade out
    };

    const displayTitle = event?.title || title;
    const displayDescription = event?.description || description;
    let eventStartsFormatted = null;

    if (!isEmpty(event)) {
        eventStartsFormatted = event.starts
            ? moment(event.starts).format(displayEventDateFormat)
            : null;
    }

    return (
        <div className={classes}>
            <Button
                className="DestinationInfoPanel-hide"
                color="secondary"
                onClick={onCloseClick}
            >
                <IconTimes />
            </Button>
            <div className="DestinationInfoPanel-container">
                {imageId && (
                    <Image
                        className="DestinationInfoPanel-image"
                        width={300}
                        height={200}
                        cloudinaryImageId={imageId}
                        alt={imageAlt}
                    />
                )}
                <div className="DestinationInfoPanel-title">
                    <h2>{displayTitle} Parking Information</h2>
                </div>
                <div className="DestinationInfoPanel-content">
                    <h2>
                        {address && <span>{unescape(address)} </span>}
                        {city && <span>{city}</span>}
                        {state && <span>, {state}</span>}
                    </h2>
                    {eventStartsFormatted && <h2>{eventStartsFormatted}</h2>}
                    <div
                        dangerouslySetInnerHTML={{__html: displayDescription}}
                    />
                </div>
            </div>
        </div>
    );
};

DestinationInfoPanel.propTypes = {
    title: PropTypes.string,
    imageId: PropTypes.string,
    imageAlt: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    description: PropTypes.string,
    event: PropTypes.object,
    displayEventDateFormat: PropTypes.string.isRequired,
    onHideInfoPanelClick: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    onHideInfoPanelClick: toggleInfoPanelView,
};

const enhance = compose(
    withConfig(['displayEventDateFormat']),
    connect(null, mapDispatchToProps)
);

export default enhance(DestinationInfoPanel);
